import lodash from "lodash";
import { CRUD_SET_VALUE, CRUD_SET_VALUE_RECURSIVE } from "./actions";

const initialStore = {
    tables: {},
    formPages: {},
};

const crudReducer = (state = initialStore, action) => {
    switch (action.type) {
        case CRUD_SET_VALUE:
            return {
                ...state,
                [action.payload.setting]: action.payload.value,
            };
        case CRUD_SET_VALUE_RECURSIVE:
            return lodash.set({ ...state }, action.payload.path, action.payload.value);
        default:
            return state;
    }
};
export default crudReducer;
